export const isNumber = (str: string): boolean => {
	if (!str) {
		return false;
	}
	if (typeof str !== 'string') {
		return false;
	}
	if (str.trim() === '') {
		return false;
	}
	return !Number.isNaN(Number(str));
};
